import Axios from './Axios'

export default Axios
